import { z } from 'zod'

export const ProfileDeliveryCertificationSchema = z.object({
  id: z.number().int(),
  name: z.string(),
  description: z.string().nullable(),
  friendly_label: z.string().nullable(),
  applies_to: z.record(z.string(), z.unknown()).nullable(),
  self_assign_allowed: z.boolean(),
  is_revocable: z.boolean().nullable(),
  created_at: z.string(),
  updated_at: z.string(),
  is_revoked: z.boolean(),
})

export const DriverCertificationsResponseSchema = z.object({
  delivery_certifications_drivers: z.array(ProfileDeliveryCertificationSchema),
})

export type ProfileDeliveryCertification = z.infer<typeof ProfileDeliveryCertificationSchema>
export type DriverCertificationsResponse = z.infer<typeof DriverCertificationsResponseSchema>
